__turbopack_context__.v({
  "exploreMapButtonContent": "InlineMap-module__-kRLua__exploreMapButtonContent",
  "heading": "InlineMap-module__-kRLua__heading",
  "mapCard": "InlineMap-module__-kRLua__mapCard",
  "mapCardOverlaid": "InlineMap-module__-kRLua__mapCardOverlaid",
  "mobileFooter": "InlineMap-module__-kRLua__mobileFooter",
  "mobileOnly": "InlineMap-module__-kRLua__mobileOnly",
  "placeholder": "InlineMap-module__-kRLua__placeholder",
  "placeholderText": "InlineMap-module__-kRLua__placeholderText",
  "section": "InlineMap-module__-kRLua__section",
});
